import styled from 'styled-components'

export const OnlyOnMobile = styled.div`
  @media (min-width: ${(p) => p.theme.chameleon.breakpoints.md}) {
    display: none;
  }
`
export const OnlyOnDesktop = styled.div`
  display: none;

  @media (min-width: ${(p) => p.theme.chameleon.breakpoints.md}) {
    display: block;
  }
`
